module.exports = __webpack_public_path__ + "r-v3/img/test_feature_image.f08b48f0.svg";